interface IBasePrinter {
    PrinterPath: string;
    PrinterAccessID: string;
    CopyCount: number;
    StartBuzzer: number;
    EndBuzzer: number;
}

export interface IPrinter extends IBasePrinter {
    PlaceDetails: IPlaceDetails;
    PrinterID: number;
    IsTestPrinting?: boolean;
    Status?: TestPrintStatusEnum;
}

export interface IUpdatePrinter extends IBasePrinter {
    PlaceID: number;
    PrinterID?: number;
}

export interface IPlaceDetails {
    PlaceID: number;
    IconId: number;
    Name: string;
    Town: string;
    PostCode: string;
    AddressLine1: string;
    AddressLine2: string;
}

export interface ITestPrintResult {
    Status: TestPrintStatusEnum;
}

export enum TestPrintStatusEnum {
    PrintingSuccess,
    PrintingError,
    PrinterNotFound
}



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/app.retailer/modules/printers/models/models.ts